import { render, staticRenderFns } from "./classServiceOne.vue?vue&type=template&id=835590fe&scoped=true&"
import script from "./classServiceOne.vue?vue&type=script&lang=ts&"
export * from "./classServiceOne.vue?vue&type=script&lang=ts&"
import style0 from "./classServiceOne.vue?vue&type=style&index=0&id=835590fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835590fe",
  null
  
)

export default component.exports